module.exports = __webpack_public_path__ + "static/media/onboarding11.e38995d8.svg";